export const CHART_DATA: Record<string, string> = {
  totalGrossRewards: 'Total gross rewards',
  totalNetRewards: 'Total net rewards',
  stakedBalance: 'Staked balance',
};

export const RANGE: Record<string, string> = {
  currentMonth: 'Current month',
  previousMonth: 'Previous month',
  '60Days': '60 days',
};
